import React from "react";

// Decodifica un valore in base alla chiave e al tipo di installazione.
export function detailsDecodeValue(key, value, installationType) {
    const stringValue = value + "";

    // STUDIO
    if (installationType === 1) {
        switch (key) {
            case "customer_type":
                switch (stringValue) {
                    case "m":
                        return "Migrazione";
                    case "n":
                        return "Nuova installazione";
                    default:
                        return stringValue;
                }
            case "http_status":
                switch (stringValue) {
                    case "1":
                        return "Attivo";
                    case "0":
                        return "Non attivo";
                    default:
                        return stringValue;
                }
            case "sys_hard":
                switch (stringValue) {
                    case "true":
                        return "Hard";
                    case "false":
                        return "Soft";
                    default:
                        return stringValue;
                }
            case "update":
                switch (stringValue) {
                    case "0":
                        return "SI";
                    case "1":
                        return "NO";
                    default:
                        return stringValue;
                }
            case "has_studio_license":
            case "has_studio_license_not_valid":
            case "has_azienda_license":
            case "has_azienda_license_not_valid":
            case "has_tu_license":
            case "has_studio_manager":
            case "has_hr_license":
            case "has_hr_license_not_valid":
            case "has_studio_manager_used":
            case "ctree_activated":
            case "has_beleader":
                switch (stringValue) {
                    case "true":
                        return "SI";
                    case "false":
                        return "NO";
                    default:
                        return stringValue;
                }
            default:
                return stringValue;
        }
    }
    // ENTERPRISE e ENTERPRISE 12
    if (installationType === 2 || installationType === 3) {
        switch (key) {
            case "backup_URL":
                if (stringValue.startsWith("http")) {
                    return (
                        <a
                            href={stringValue}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Download backup
                        </a>
                    );
                }
                break;
            default:
                return stringValue;
        }
    }

    // Default: restituisce il valore come stringa
    return stringValue;
}

// Restituisce la traduzione della chiave in base al tipo di installazione.

export function detailsRenderKey(key, installationType) {
    // STUDIO (installationType === 1)
    if (installationType === 1) {
        switch (key) {
            case "volume_state":
                return "DISK: stato";
            case "customer_type":
                return "Tipo installazione";
            case "sys_ram":
                return "SYS: RAM riservata";
            case "redis_db":
                return "REDIS: Numero Database";
            case "uas":
                return "TSEXP: Pdl";
            case "installation_id":
                return "ID Installazione";
            case "rds_host":
                return "RDS: Hostname";
            case "status":
                return "ECS: Stato servizio";
            case "desired_count":
                return "ECS: Numero container desiderato";
            case "http_port":
                return "HTTP: Porta interna";
            case "redis_host":
                return "REDIS: Hostname";
            case "url":
                return "TSEXP: Portale Url";
            case "volume_pused":
                return "DISK: percentuale uso";
            case "http_status":
                return "HTTP: Stato servizio";
            case "company":
                return "P.IVA Azienda";
            case "image":
                return "DOCKER: Immagine";
            case "cluster_private_ip":
                return "CLUSTER: IP Privato";
            case "sys_cpu":
                return "SYS: CPU";
            case "running_count":
                return "ECS: Numero container running";
            case "version":
                return "TSEXP: Versione";
            case "rds_user":
                return "RDS: Utente";
            case "volume_name":
                return "DISK: nome";
            case "cluster_name":
                return "CLUSTER: Nome";
            case "rds_db_tse":
                return "RDS: DB TSExperience";
            case "volume_size":
                return "DISK: dimensione";
            case "update":
                return "TSEXP: Aggiornabilità";
            case "ctree_port":
                return "CTREE: Porta interna";
            case "ctree_activated":
                return "CTREE attivo";
            case "alb":
                return "ALB";
            case "sys_hard":
                return "SYS: Tipologia";
            case "customer":
                return "Codice cliente";
            case "volume_mount_point":
                return "DISK: percorso";
            case "type":
                return "Tipologia cliente";
            case "cluster_instance_id":
                return "CLUSTER: Instance ID";
            case "base_license_release_date":
                return "TSEXP: Data rilascio licenza base (5008)";
            case "container_id":
                return "DOCKER: ID";
            case "created":
                return "Data creazione";
            case "has_studio_manager":
                return "Ha licenze STUDIO Manager";
            case "last_modified":
                return "Data ultima variazione";
            case "sys_ram_limit":
                return "SYS: RAM Limite massimo";
            case "has_studio_license":
                return "Ha licenze Studio (5060)";
            case "has_studio_license_not_valid":
                return "Lic. Studio non SaaS o scaduta";
            case "has_azienda_license":
                return "Ha licenze Azienda (5066)";
            case "has_azienda_license_not_valid":
                return "Licenze Azienda non SaaS o scaduta";
            case "has_tu_license":
                return "Ha licenze TU";
            case "application_user_last_login":
                return "Ultimo login";
            case "has_hr_license":
                return "Ha licenze HR";
            case "has_hr_license_not_valid":
                return "Licenze HR non SaaS o scadute";
            case "has_studio_manager_used":
                return "Usa STUDIO Manager";
            case "has_beleader":
                return "Ha aziende BeLeader";
            case "has_beleader_pdl":
                return "Pdl BeLeader";
            case "piva_cf_cliente":
                return "piva/cf cliente (licenza)";
            case "piva_cf_rivenditore":
                return "piva/cf azienda (licenza)";
            default:
                return key;
        }
    }

    if (installationType === 2) {
    }
    if (installationType === 3) {
    }

    return key;
}



// WEBPACK FOOTER //
// ./src/common/detailsDecodeValue.js